export default __webpack_public_path__ + "static/media/checklist.bc7429e6.svg";